import React from "react";

function Download() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_123_5029)">
        <path
          d="M5.25002 6.41699V9.91699M5.25002 9.91699L6.41669 8.75033M5.25002 9.91699L4.08335 8.75033M12.8334 5.83366V8.75033C12.8334 11.667 11.6667 12.8337 8.75002 12.8337H5.25002C2.33335 12.8337 1.16669 11.667 1.16669 8.75033V5.25033C1.16669 2.33366 2.33335 1.16699 5.25002 1.16699H8.16669M12.8334 5.83366L10.5 5.83366C8.75002 5.83366 8.16669 5.25033 8.16669 3.50033V1.16699M12.8334 5.83366L8.16669 1.16699"
          stroke="#E3C1A3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_123_5029">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Download;
